import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe extends SafariInjector implements PipeTransform {
  #sanitizer: DomSanitizer;
  constructor() {
    super();
    this.#sanitizer = this.inject(DomSanitizer);
  }
  transform(url) {
    return this.#sanitizer.bypassSecurityTrustHtml(url);
  }
}
